// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__DfUhZ","genericError":"Form_genericError__VuDTw"};